import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from './AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css';

const ManageMenus = () => {
  const [openMenus, setOpenMenus] = useState([]);
  const [allMenuTypes, setAllMenuTypes] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const { token } = useAuth();

  const authHeaders = { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' };

  const fetchOpenMenus = useCallback(async () => {
    try {
      const res = await fetch('https://api.reshipesbakery.com/reshipes/getOpenMenus', { headers: authHeaders });
      if (res.ok) setOpenMenus(await res.json());
    } catch {}
  }, [token]);

  useEffect(() => {
    fetchOpenMenus();
    fetch('https://api.reshipesbakery.com/reshipes/getMenuTypes', { headers: authHeaders })
      .then(r => r.ok ? r.json() : [])
      .then(setAllMenuTypes)
      .catch(() => {});
  }, [token]);

  const flash = (msg, isError = false) => {
    if (isError) { setError(msg); setSuccess(null); }
    else { setSuccess(msg); setError(null); }
  };

  const handleOpen = async () => {
    setError(null);
    setSuccess(null);
    try {
      const res = await fetch(
        `https://api.reshipesbakery.com/reshipes/turnOnOrders?menuType=${encodeURIComponent(selectedMenu)}`,
        { method: 'POST', headers: authHeaders }
      );
      const body = await res.json().catch(() => null);
      if (!res.ok) throw new Error(body?.detail || 'Failed to open menu');
      flash(`${selectedMenu} is now open.`);
      setSelectedMenu('');
      fetchOpenMenus();
    } catch (e) {
      flash(e.message, true);
    }
  };

  const handleClose = async (menuType) => {
    setError(null);
    setSuccess(null);
    try {
      const res = await fetch(
        `https://api.reshipesbakery.com/reshipes/turnOffOrders?menuType=${encodeURIComponent(menuType)}`,
        { method: 'POST', headers: authHeaders }
      );
      if (!res.ok) throw new Error('Failed to close menu');
      flash(`${menuType} has been closed.`);
      fetchOpenMenus();
    } catch (e) {
      flash(e.message, true);
    }
  };

  const availableMenuTypes = allMenuTypes.filter(m => !openMenus.some(o => o.menuType === m));

  return (
    <div className="container mt-5" style={{ maxWidth: 700 }}>
      <h1>Manage Order Forms</h1>

      {error && <div className="alert alert-danger mt-3">{error}</div>}
      {success && <div className="alert alert-success mt-3">{success}</div>}

      <h4 className="mt-4">Currently Open</h4>
      {openMenus.length === 0 ? (
        <p className="text-muted">No menus are currently open.</p>
      ) : (
        openMenus.map(menu => (
          <div key={menu.id} className="card mb-3">
            <div className="card-body d-flex justify-content-between align-items-center">
              <h5 className="card-title mb-0">{menu.menuType}</h5>
              <button className="btn btn-danger btn-sm" onClick={() => handleClose(menu.menuType)}>
                Close
              </button>
            </div>
          </div>
        ))
      )}

      <h4 className="mt-5">Open a New Menu</h4>
      <div className="card">
        <div className="card-body">
          <div className="mb-3">
            <label className="form-label fw-semibold">Menu Type</label>
            <select className="form-select" value={selectedMenu} onChange={e => setSelectedMenu(e.target.value)}>
              <option value="">Select a menu…</option>
              {availableMenuTypes.map(m => <option key={m} value={m}>{m}</option>)}
            </select>
          </div>
          <button className="btn btn-success" disabled={!selectedMenu} onClick={handleOpen}>
            Open Menu
          </button>
        </div>
      </div>
    </div>
  );
};

export default ManageMenus;
